module.exports = __webpack_public_path__ + "static/media/google-play.90c8da0f.png";